import styled, { css } from "styled-components";
import { color, snap, units } from "@m/alchemy-theme";
import { AppNavOverflowButtonWrapper } from "../app-menu-button/AppNavOverflowButton.styled";
import { Wrapper as OverflowCollapse } from "../../overflow-collapse/OverflowCollapse.styled";
import { FocusList } from "../../utilities/focus-list/FocusList";
import { MOBILE_BREAKPOINT } from "../constants";
import { navHeight } from "../navHeight";
import { AppMenuButtonIconWrapper } from "../app-menu-button/AppMenuButton.styled";
import { AppNavListItemTertiary } from "./AppNavListItemTertiary.styled";
// NOTE:
// OverflowCollapse overrides are in AppNav because we don't always have access to OverflowCollapse
// depending on how nav is implemented
export const AppNav = styled.nav `
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-right: ${units(4)};

  ${OverflowCollapse} {
    /*
     * 1. Hide overflow so when resizing the overflowed element doesn't show for split second
     * 2. Add some left padding so that when text gets bigger it doesn't overflow
     * 3. Add negative margin to line back up.
    */
    overflow: hidden;
    padding-left: ${units(1.5)};
    margin-left: -${units(1.5)};

    ${({ priority }) => priority &&
    css `
        ${navHeight({ priority })};
      `};
  }

  /* first LI in each nav list, don't include overflow LI which also has a UL */
  /* Padding in first LI A remains for dot calculations, need to adjust margin left because of it */
  ${OverflowCollapse} > li:first-child a {
    padding-left: 0;
  }

  /* because secondary nav isn't aligned center and AppNavOverflowButton
  doesn't know about priority need to do this for overflow arrow not on mobile */
  @media (min-width: ${MOBILE_BREAKPOINT}px) {
    ${OverflowCollapse} ${AppNavOverflowButtonWrapper} {
      padding-top: ${({ priority }) => (priority === "secondary" ? "18px" : 0)};
    }
  }

  /* LI controlled by OverflowCollapse */
  li[aria-hidden="false"] {
    display: flex;
    align-items: center;
    justify-content: center;

    /* Hide tertiary nav arrow if selected and collapsed into OverflowCollapse button (there is already another arrow shown) */
    ${AppNavListItemTertiary} {
      ${AppMenuButtonIconWrapper} {
        display: none;
      }
    }
  }
`;
export const AppNavFocusList = styled(FocusList).attrs({
    elementType: "div",
    itemSelector: "button,a,[tabindex]",
    focusManagementStrategy: "tabOrder",
    keyboardDirection: "horizontal"
}) `
  position: relative;
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-wrap: nowrap;
`;
export const AppNavOverflowWrapper = styled.div `
  max-height: ${snap(600)};
  overflow-y: auto;
  overflow-x: visible;
`;
export const AppNavIndicator = styled.div `
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  position: absolute;
  background-color: ${color("typeHeader")};
  transition: all cubic-bezier(0.4, 0, 0.4, 1) 0.2s;
`;
